import React, { useEffect } from 'react';
import { ReactComponent as Visa } from '@ui-kit/images/visa.svg';
import { ReactComponent as MasterCard } from '@ui-kit/images/mastercard.svg';
import { ReactComponent as BlankCard } from '@ui-kit/images/creditcard.svg';
import { useState } from 'react';

export type CreditCardType = 'VISA card' | 'MasterCard';

export default function CardType(props: {
  cardNumber?: string;
  onChange: (cardType?: CreditCardType) => void;
}) {
  const [type, setType] = useState<CreditCardType>();

  useEffect(() => {
    const t = cardType(props.cardNumber);
    setType(t);
    props.onChange(t);
  }, [props.cardNumber]);

  switch (type) {
    case 'MasterCard':
      return <MasterCard />;
    case 'VISA card':
      return <Visa />;
    default:
      return <BlankCard />;
  }
}

function cardType(cardNumber?: string): CreditCardType | undefined {
  if (!cardNumber) return undefined;
  if (cardNumber[0] === '4') return 'VISA card';
  if (['50', '51', '52', '53', '54', '55'].includes(cardNumber.slice(0, 2)))
    return 'MasterCard';
  return undefined;
}
